import React from 'react';
import { useAuth } from './contexts/AuthContext';
import SplashScreen from './pages/SplashScreen';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import Clients from './pages/Clients';
import ClientDetails from './pages/ClientDetails';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import AgentProfile from './pages/AgentProfile';
import Services from './pages/Services';
import Technicians from './pages/Techniciens';
import Brands from './pages/Brands';
import Orders from './pages/OrdersList';
import OrderDetails from './pages/OrderDetails';
import VehicleDetails from './pages/VehiculeDetails';
import Banners from './pages/Banners';
import Companies from './pages/Companies';
import CompanyDetails from './pages/Companies/CompanyDetails';
import ReservationList from './pages/Reservations';
import ReservationListT from './pages/ReservationsT';
import BannersWebsite from './pages/BannersWebsite';
import LoginT from './pages/LoginT';
import Agents from './pages/Agents';

const AppContent: React.FC = () => {
  const { loading, isAuthenticated,type } = useAuth();

  const PrivateRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
    return isAuthenticated ? element : <Navigate to="/login" replace />;
  };

  if (loading  ) {
    return <SplashScreen />;
  }

  return (
    <Router>
      <Routes>

        <Route path="/login" element={<Login />} />
        <Route path="/technicien-login" element={<LoginT />} />

        {!isAuthenticated && <Route path="/" element={<Login />} />}
        {type=='agent' && 
         <> 
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Dashboard />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/clients"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Clients />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/vehicles/:id"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <VehicleDetails />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/companies"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Companies />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/companies/:id"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <CompanyDetails />
                </DashboardLayout>
              }
            />
          }
        /> 
        <Route
          path="/clients/:id"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <ClientDetails />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/orders"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Orders />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/reservations"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <ReservationList />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/orders/:id"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <OrderDetails />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/services"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Services />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <AgentProfile />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/technicians"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Technicians />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/agents"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Agents />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/brands"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Brands />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/banners"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <Banners />
                </DashboardLayout>
              }
            />
          }
        />
        <Route
          path="/banners/website"
          element={
            <PrivateRoute
              element={
                <DashboardLayout>
                  <BannersWebsite />
                </DashboardLayout>
              }
            />
          }
        /></>}
        {/* TECHNICIEN ROUTES */}
        {type=='technicien' && <>
          <Route path="/" element={<Navigate to="/technicien" replace />} />
        <Route
          path="/technicien"
          element={
            <PrivateRoute
              element={
                  <ReservationListT />
              }
            />
          }
        />
                <Route
          path="/profile"
          element={
            <PrivateRoute
              element={
                  <AgentProfile />
              }
            />
          }
        />
      </>}
      </Routes>
    </Router>
  );
};

export default AppContent;